import { useCallback, useState } from 'react'

const DEFAULT_PAGE_SIZE = 100

export interface UsePaginationResult {
  currentPage: number
  setCurrentPage: (page: number) => void
  pageSize: number
  setPageSize: (pageSize: number) => void
  resetPage: () => void
  getOffset: (page: number, pageSize: number) => number
}

export const usePagination = (): UsePaginationResult => {
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)

  const resetPage = useCallback(() => setCurrentPage(1), [])

  const getOffset = useCallback(
    (page: number, pageSize: number) => (page - 1) * pageSize,
    []
  )

  return {
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    resetPage,
    getOffset
  }
}
